import React from 'react';
import { useSelector } from 'react-redux';

import { getCurrentProject } from '@neptune/current-project-business-logic';
import { ProjectHeader } from '@neptune/project-ui';

type CompareProjectHeaderContainerProps = {
  tabs: React.ReactNode;
  additionalElementRef?: React.ForwardedRef<HTMLElement>;
  lbViewPicker?: React.ReactNode;
  colorListPicker?: React.ReactNode;
};

export const CompareProjectHeaderContainer: React.FC<CompareProjectHeaderContainerProps> = ({
  tabs,
  additionalElementRef,
  lbViewPicker,
  colorListPicker,
}) => {
  const project = useSelector(getCurrentProject);

  if (!project) {
    return null;
  }

  return (
    <ProjectHeader
      tabs={tabs}
      lbViewPicker={lbViewPicker}
      colorListPicker={colorListPicker}
      additionalElementRef={additionalElementRef}
    />
  );
};
